<template>
  <div class="h-full p-12 mx-auto bg-gray-100 rounded-lg">
    <div class="max-w-xl">
      <FormulateForm
        name="createCompany"
        v-model="formValues"
        @submit="createCompany"
        class="mb-6"
      >
        <h1 class="font-bold text-3xl mb-8">
          Create a new Company
        </h1>

        <FormulateInput
          name="name"
          type="text"
          label="Company name"
          placeholder="Name"
          validation="bail|required"
        />
        <FormulateErrors />
        <base-button type="submit" :loading="creating">
          Create
        </base-button>
      </FormulateForm>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      creating: false,
      formValues: {},
    };
  },
  methods: {
    async createCompany(data) {
      try {
        this.creating = true;
        const createdCompany = await this.$api.post('companies/', data);
        await this.$store.dispatch('auth/getUserRoles');
        this.$store.commit('company/addCompany', createdCompany.data);
        this.$store.dispatch('company/changeCompany', createdCompany.data.id);
        this.$router.push({ name: 'admin-general' });
      } catch (error) {
        this.$formulate.handle(error, 'createCompany');
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>
